exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[admin-footer]{background:#222;color:#999}[admin-footer] .wrapper{padding:2.08333333rem 0}[admin-footer] .wrapper p{font-size:1.16666667rem;line-height:1.8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d9b3276","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/common/AppFooter.vue
// module id = I+aY
// module chunks = 241